import {BaseConverter} from "../../base/converters/base-converter.converter";
import {ServiceHistoryModel} from "../models/service-history.model";
import {ServiceHistory} from "../../shared/DTO/serviceHistory";
import * as moment from "moment";
import {Injectable} from "@angular/core";

@Injectable()
export class ServiceHistoryConverter extends BaseConverter<ServiceHistoryModel, ServiceHistory> {
  convertToDto(model: ServiceHistoryModel): ServiceHistory {
    if (!model) {
      return;
    }
    return {
      activationDate: model.activationDate?.toISOString() || undefined,
      code: model.code,
      contractValidation: model.contractValidation,
      expectedContract: model.expectedContract,
      extraNotes: model.extraNotes,
      insertDate: model.insertDate?.toISOString() || undefined,
      measurementUnit: model.measurementUnit,
      notes: model.notes,
      quantity: model.quantity,
      state: model.state,
      subscription: model.subscription
    };
  }

  convertToModel(dto: ServiceHistory): ServiceHistoryModel {
    if (!dto) {
      return;
    }
    let model: ServiceHistoryModel = new ServiceHistoryModel();
    model.subscription = dto.subscription;
    model.state = dto.state;
    model.quantity = dto.quantity;
    model.notes = dto.notes;
    model.measurementUnit = dto.measurementUnit;
    model.insertDate = dto.insertDate ? moment(dto.insertDate) : null;
    model.extraNotes = dto.extraNotes;
    model.expectedContract = dto.expectedContract;
    model.contractValidation = dto.contractValidation;
    model.code = dto.code;
    model.activationDate = dto.activationDate ? moment(dto.activationDate) : null;
    return model;
  }

}
